import { reactWebAppHref } from "./reactWebAuthUrl";

/** Header/footer "Find Pilots" hands off to the react-web directory guest paywall. */
export function isDirectoryHandoffMenuId(menuId: string): boolean {
  return menuId === "find-pilots";
}

export function marketplaceMenuHref(
  locale: string,
  item: Readonly<{ href: string; id: string }>,
): string {
  if (isDirectoryHandoffMenuId(item.id)) {
    return reactWebAppHref(locale, "directory");
  }
  return item.href.startsWith("/") ? item.href : `/${item.href}`;
}
